import React, { useState, useEffect } from 'react';
import { usePT } from '../utils/promoteTranslations';

const TranscriptionDisplay = ({ words, currentTime, isPlaying }) => {
  const pt = usePT();
  const [currentLine, setCurrentLine] = useState('');
  const [displayedWords, setDisplayedWords] = useState([]);

  // Groupe les mots en phrases (environ 5-8 mots par ligne)
  const WORDS_PER_LINE = 6;

  useEffect(() => {
    if (!words || words.length === 0) return;

    // Trouve l'index du mot actuel
    const currentWordIndex = words.findIndex((word, i) => {
      const nextWord = words[i + 1];
      return (
        currentTime >= word.start &&
        (!nextWord || currentTime < nextWord.start)
      );
    });

    if (currentWordIndex === -1) {
      setCurrentLine('');
      setDisplayedWords([]);
      return;
    }

    // Calculer quelle "ligne" on est en train de lire
    const lineIndex = Math.floor(currentWordIndex / WORDS_PER_LINE);
    const startIndex = lineIndex * WORDS_PER_LINE;
    const endIndex = Math.min(startIndex + WORDS_PER_LINE, words.length);

    // Récupérer les mots de la ligne actuelle
    const lineWords = words.slice(startIndex, endIndex);
    
    // Construire la ligne avec le mot actuel surligné
    const wordsInLine = lineWords.map((word, idx) => ({
      text: word.word,
      active: startIndex + idx === currentWordIndex
    }));

    setDisplayedWords(wordsInLine);

  }, [currentTime, words]);

  if (!words || words.length === 0) {
    return null;
  }

  return (
    <div
      className="px-6 py-4 bg-gradient-to-r from-black/60 to-black/40 rounded-2xl backdrop-blur-md border border-white/10"
      data-testid="transcription-display"
    >
      <div className="text-center text-xl leading-relaxed min-h-[3rem] flex items-center justify-center">
        {displayedWords.length > 0 ? (
          <p className="font-medium">
            {displayedWords.map((word, index) => (
              <span
                key={index}
                className={`inline-block mx-1.5 transition-all duration-300 ${
                  word.active
                    ? 'text-magenta-400 font-bold scale-110 drop-shadow-[0_0_8px_rgba(236,72,153,0.6)]'
                    : 'text-gray-300'
                }`}
              >
                {word.text}
              </span>
            ))}
          </p>
        ) : (
          <p className="text-gray-500 text-base italic">🎵 {pt('feed.playingNow')}</p>
        )}
      </div>
    </div>
  );
};

export default TranscriptionDisplay;
